import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vertical-copyright',
  template: `
    <div class="vertical-copyright-wrap">
      <a target="_blank" href="https://silvanohebert.com.br/">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.455 13">
          <path
            d="M8.459,3.347H6.939v3.07l-4.2-2.572a.628.628,0,0,1-.249-.5V2.489H4.727V0H2.018A2.012,2.012,0,0,0,0,2.019V8.243L2.488,9.764v-3.1l4.23,2.572a.616.616,0,0,1,.249.47v.111a.685.685,0,0,1-.691.691H4.727V13H7.436a2.03,2.03,0,0,0,2.018-2.019V4.315A1,1,0,0,0,8.459,3.347Z"
            fill="#fff"
          />
        </svg>
      </a>
      <p>© Copyright {{ currentDate | date:'yyyy' }} Sonora Musical. Todos os direitos reservados.</p>
    </div>
  `,
  styles: [
    `
      .vertical-copyright-wrap {
        display: flex;
      }

      svg {
        display: block;
        width: 0.24rem;
        transform: rotate(90deg);
        margin-right: 1.3rem;
      }

      p {
        color: white;
        font-family: 'Metronic Pro', sans-serif;
        font-size: 0.28rem;
        margin: 0;
        padding: 0;
        opacity: 0.5;
        font-weight: 800;
      }
    `
  ]
})
export class VerticalCopyrightComponent implements OnInit {

  currentDate = new Date();

  constructor() {}

  ngOnInit() {}
}
